module.exports = __webpack_public_path__ + "static/img/icon_verify.43307343.svg";